export default __webpack_public_path__ + "media/images/metal_detect/foxes_detect_1-7b4f07fea0b97151be47be61ca82ec46.svg";